// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2zAl-","active":"downloadDropdown_active__3xINs"};